import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getUser } from '../actions/userAction';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { updateData } from '../actions/dataAction';
import Timeline from './dataViews/Timeline/Timeline';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faArrowLeft from '@fortawesome/fontawesome-free-solid/faArrowLeft';


const GridContainer = styled.div`
  margin-left:10px;
  margin-right:10px;

  > div {
    margin-top: 70px;

    .main-cols {
      height: calc(100vh - 139px);
      display: flex;
      flex-direction: column;
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  > div.hide-back-btn {
    margin-top: 90px;

    .main-cols {
      height: calc(100vh - 130px);
      display: flex;
      flex-direction: column;
      padding-left: 10px;
      padding-right: 10px;
    }
  }


  @media only screen and (max-width: 991px), print {
    > div {

      .main-cols {
        height: auto;
        margin-bottom: 20px;
      }
    }

    > div.hide-back-btn {
      display: flex;
      flex-direction: column-reverse;

      .main-cols {
        height: auto;
      }
    }
  }

  @media print {
    > div {
      display: block !important;
      margin-top: 20px !important;

      .main-cols {
        display: block !important;
      }
    }

    > div.hide-back-btn {
      display: block !important;
      margin-top: 20px !important;

      .main-cols {
        display: block !important;
      }
    }
  }

`;

const BackButtonContainer = styled.div`
  display: block;
  margin-left: 25px;
  margin-top: 70px;
  margin-bottom: 15px;
`

const BackButton = styled(Link)`

  color: #fff;
  text-transform: uppercase;

  &:hover {
      color: #fff;
  }

  @media print {
    display: none;
  }

  ${props => props.secondary && css`
    margin-left: 25px;
  `}

`;

const LeftArrow = styled(FontAwesomeIcon)`
    margin-right:10px;
`;

class App extends Component {
  renderColumns(columns) {
    return _.map(columns, (col, key) => {
      return (<div key={key} className={`main-cols ${this.props.columns[key]}`} >
              {col.components}
          </div>);
    });
  }
  renderTimeline() {
    if (process.env.REACT_APP_TIMELINE_ACTIVE === "true") {
      return <Timeline/>;
    }
  }
  render() {
    return (
      <GridContainer>
        <div className={this.props.showBackButton ? 'show-back-btn' : 'hide-back-btn'}>

          <BackButtonContainer>
            {this.props.showBackButton && <BackButton to={this.props.backTo || "/"} className="backButton small-font-size"><LeftArrow icon={faArrowLeft} />{this.props.backButtonText || "Return to brand health"}</BackButton>}
            {this.props.showBackButton && this.props.showSecondaryButton && <BackButton to={"/recommendations"} className="backButton small-font-size" secondary><LeftArrow icon={faArrowLeft} />{this.props.SecondaryButtonText || "Recommendations"}</BackButton>}
          </BackButtonContainer>

          {this.renderColumns(this.props.components)}
          {this.renderTimeline()}

        </div>
      </GridContainer>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    data: state.data
  };
}

export default connect(mapStateToProps, { getUser, updateData })(App);



// WEBPACK FOOTER //
// ./src/components/GridView.js